import * as React from 'react';
import { REBUTTAL_TAGS } from '@constants';

const RebuttalsContext = React.createContext();
const { moreInformation, ficoAndCredit, VCL, video } = REBUTTAL_TAGS;

export const RebuttalsProvider = (props) => {
    const { slideId, rebuttals, dispatch } = props;
    
    let ficoRebuttals = null; 
    let moreInfoRebuttals = null; 
    let vclRebuttals = null; 
    let videoRebuttals = null;

    if (rebuttals) {
        ficoRebuttals = getTags(ficoAndCredit);
        moreInfoRebuttals = getTags(moreInformation);
        vclRebuttals = getTags(VCL);
        videoRebuttals = rebuttals.filter(slide => !!slide.videoUrl);
    }
    
    function getTags(tagName, slides = rebuttals) {
        return slides.filter(slide => slide.tags && slide.tags.includes(tagName));
    }

    const rebuttalsBySection = { 
        slideId,  
        ficoRebuttals, 
        moreInfoRebuttals, 
        vclRebuttals, 
        videoRebuttals,
        dispatch
    };

    return (
        <RebuttalsContext.Provider value={rebuttalsBySection} {...props} />
    );
};

export const useRebuttals = (rebuttalType) => {
  const rebuttals = React.useContext(RebuttalsContext);

  if (rebuttals === undefined) {
    throw new Error('useRebuttals must be used within a RebuttalsProvider');
  } 

  const { 
    slideId, 
    ficoRebuttals, 
    moreInfoRebuttals, 
    vclRebuttals, 
    videoRebuttals, 
    dispatch } = rebuttals;

  const data = {
      selectedRebuttals: [],
      dispatch,
      slideId
  };
  
  switch (rebuttalType) {
      case ficoAndCredit:
        data.selectedRebuttals = ficoRebuttals;
        break;
      case moreInformation:
        data.selectedRebuttals = moreInfoRebuttals;
        break;
      case VCL:
        data.selectedRebuttals = vclRebuttals;
        break;
      case video:
        data.selectedRebuttals = videoRebuttals;
        break;
      default:
        console.error(`Couldn't find matching rebuttal data for type ${rebuttalType}`);
  }

  return data;
};
